import React from 'react';
import TestimonialCard from './TestimonialCard';
import './TestimonialSection.css';
import testiomonial1 from "../../assets/imgs/Testimonial/1.png"
import testiomonial2 from "../../assets/imgs/Testimonial/2.png"
import testiomonial3 from "../../assets/imgs/Testimonial/3.jpg"
import testiomonial4 from "../../assets/imgs/Testimonial/4.jpg"

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      photoUrl:testiomonial1 ,
      name: "Nahom Sintayehu",
      role: "CEO, Urban Productions",
      testimonial: "Eskista has been a trusted and indispensable partner to our company  for several years. As our primary provider, Eskista consistently delivers top-quality gear that meets the high standards required for our productions — from commercial shoots to corporate content and creative storytelling"
    },
    {
      id: 2,
      photoUrl: testiomonial2,
      name: "Abigaiel Eskinder",
      role: "Channel Manager, Fendisha YouTube Channel",
      testimonial: "Fendisha TV would be nothing without Eskista! The top-notch equipment and collaborative team have been essential to creating our YouTube channel. Every week, we are able to deliver high quality videos to our loyal audience,.Thank you so much Eskista!"
    },
    {
      id: 3,
      photoUrl: testiomonial3,
      name: "Diribdil Assefa",
      role: "Founder, G. Managr, Rusty Town Production",
      testimonial: "Eskista has been an essential partner in the production of our sitcom “Gira Kegn,” aired on EBC. They provided video & sound equipment, reliable talent sourcing, and seamless pickup and delivery services. Their professionalism and efficiency greatly contributed to the success of our  show."
    },
    {

      id: 4,
      photoUrl: testiomonial4,
      name: "Benjamin Raymond",
      role: "Interzone Pictures Producer",
      testimonial: "We hired camera equipment from Daniel and his team at Eskita Ethiopia for a shoot in Semera, and the service was exceptional from start to finish. Collection in Addis Ababa was smooth and efficient. Daniel and his team went above and beyond to make sure we had everything we needed, carefully packing the gear for air travel. They were quick to respond to any technical issues and helped us resolve them without delay. The whole experience was professional, reliable, and offered at a very fair rate. Highly recommended."
    }
  ];

  return (
    <section id="testimonial-section" className="testimonial-section-container">
      <div className="testimonial-section-header">
        <h2 className="testimonial-section-title">What Our Clients Say</h2>
        <p className="testimonial-section-subtitle">
          Hear from filmmakers, photographers, and creatives who've used our services
        </p>
      </div>
      
      <div className="testimonial-cards-container">
        {testimonials.map((testimonial) => (
          <TestimonialCard
            key={testimonial.id}
            photoUrl={testimonial.photoUrl}
            name={testimonial.name}
            role={testimonial.role}
            testimonial={testimonial.testimonial}
          />
        ))}
      </div>
    </section>
  );
};

export default TestimonialSection;